import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniabusonrentinshirdi() {



    const cardData =
    {
        keyword: 'Urbania Bus On Rent in Shirdi',
        heading: 'Urbania on rent in pune: Urbania Bus On Rent in Shirdi',
        headingDescription: 'Urbania On Rent in Pune offers premium and dependable Urbania Bus On Rent in Shirdi for corporate groups, families, pilgrims, and event travelers planning comfortable group travel to and from Shirdi. Our well-maintained Force Urbania bus fleet provides spacious seating, powerful air-conditioning, and smooth performance, making it ideal for long-distance journeys, airport transfers, corporate outings, weddings, sightseeing tours, and outstation trips between Pune and Shirdi. With professional chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe, punctual, and stress-free travel experience. Backed by 24/7 booking support, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the trusted choice for Urbania bus hire in Shirdi.',

        top: 'Top Places to Visit in Shirdi with Urbania on rent in pune',


"topPlaces": [
  {
    "title": "Shri Sai Baba Samadhi Mandir",
    "description": "Shri Sai Baba Samadhi Mandir is the heart of Shirdi and one of India’s most visited pilgrimage sites. Built at the place where Sai Baba attained samadhi, the temple houses his sacred marble idol and samadhi. Devotees from all over the world visit to seek blessings, attend aartis, and experience the peaceful spiritual atmosphere. The temple complex is well-organized and includes meditation areas, queues, and facilities for pilgrims."
  },
  {
    "title": "Dwarkamai",
    "description": "Dwarkamai is the sacred mosque where Sai Baba lived for many years and performed miracles. It holds immense spiritual significance, featuring the holy dhuni (sacred fire) that has been continuously burning since Sai Baba’s time. Devotees believe that Dwarkamai symbolizes unity, faith, and compassion, making it an essential stop for every visitor to Shirdi."
  },
  {
    "title": "Chavadi",
    "description": "Chavadi is a historic place where Sai Baba used to sleep on alternate nights during the later part of his life. The ceremonial procession from Dwarkamai to Chavadi is still followed on Thursdays and special occasions. The site displays Baba’s belongings, including his wooden bed and photographs, offering deep insights into his simple lifestyle."
  },
  {
    "title": "Gurusthan",
    "description": "Gurusthan is the place under a neem tree where Sai Baba was first seen meditating after arriving in Shirdi. It is considered one of the most sacred spots in the town. Devotees offer prayers and incense here, believing it fulfills wishes and brings spiritual peace. The neem tree is believed to possess divine healing properties."
  },
  {
    "title": "Lendi Baug",
    "description": "Lendi Baug is a serene garden developed by Sai Baba himself, where he spent time meditating and walking. The garden features the sacred Nanda Deep (eternal lamp), a small shrine, and peaceful surroundings. Visitors experience tranquility and a strong spiritual connection while spending time here."
  },
  {
    "title": "Khandoba Temple",
    "description": "Khandoba Temple is the first temple Sai Baba visited upon arriving in Shirdi. It holds historical and religious importance, as it marks the beginning of Baba’s spiritual journey in the village. Devotees visit this temple to seek blessings before proceeding to the main shrine."
  },
  {
    "title": "Shri Sai Baba Museum",
    "description": "The Sai Baba Museum houses personal belongings of Sai Baba, including utensils, clothes, footwear, and photographs. The exhibits provide insights into his simple lifestyle, teachings, and daily routine. It is a meaningful place for devotees to connect more deeply with Baba’s life and philosophy."
  },
  {
    "title": "Abdul Baba Cottage",
    "description": "Abdul Baba Cottage is dedicated to Sai Baba’s close disciple, Abdul Baba, who served him with devotion. The cottage preserves memories, photographs, and artifacts related to Baba’s life. It reflects the deep bond between the saint and his followers and highlights values of service and devotion."
  },
  {
    "title": "Sai Heritage Village",
    "description": "Sai Heritage Village is a theme park depicting scenes from Sai Baba’s life through life-size statues and recreated settings. Visitors can understand Baba’s teachings, miracles, and way of living in an engaging and visual manner. It is especially popular among families and first-time visitors."
  },
  {
    "title": "Wet N Joy Water Park (Nearby)",
    "description": "Located near Shirdi, Wet N Joy Water Park offers a refreshing recreational experience for families and tourists. With thrilling rides, wave pools, and relaxation zones, it provides a fun break from spiritual sightseeing. It is a popular attraction for visitors staying longer in Shirdi."
  }
],






"services": [
{
"name": "Urbania Bus on Rent in Shirdi",
"description": "Urbania Bus on Rent in Shirdi offers reliable and well-maintained Urbania buses for local and outstation travel. Ideal for families, pilgrims, corporate groups, and tourists, these buses provide comfort, spacious seating, and professional chauffeur service for a hassle-free journey across Shirdi."
},
{
"name": "Shirdi Urbania Bus Hire",
"description": "Shirdi Urbania Bus Hire provides convenient rental services with AC and non-AC buses for temple darshan, city travel, sightseeing, and group tours. Perfect for families, pilgrims, and groups, ensuring a comfortable and safe journey."
},
{
"name": "Urbania Rental Service Shirdi",
"description": "Urbania Rental Service Shirdi offers flexible rental options for Urbania buses with professional drivers, suitable for pilgrimage tours, family outings, corporate events, and outstation trips."
},
{
"name": "Urbania AC Bus on Rent Shirdi",
"description": "Urbania AC Bus on Rent Shirdi provides fully air-conditioned Urbania buses for comfortable temple visits, city travel, and long-distance journeys. Ensures a smooth ride with climate-controlled interiors and experienced chauffeurs."
},
{
"name": "Corporate Urbania Hire Shirdi",
"description": "Corporate Urbania Hire Shirdi delivers professional transport solutions for business travel, office events, and corporate pilgrimages. Features include AC buses, punctual service, and trained drivers for a seamless corporate experience."
},
{
"name": "Urbania for Outstation Shirdi",
"description": "Urbania for Outstation Shirdi offers AC and non-AC buses for long-distance travel, including pilgrimage circuits, weekend getaways, sightseeing tours, and intercity trips. Provides luggage support, comfortable seating, and courteous drivers familiar with the routes."
},
{
"name": "Urbania Airport Transfer Shirdi",
"description": "Urbania Airport Transfer Shirdi provides timely pick-up and drop services to and from Shirdi Airport. Ideal for pilgrims, tourists, and corporate travelers seeking stress-free, comfortable, and punctual airport transport."
},
{
"name": "Luxury Urbania Shirdi",
"description": "Luxury Urbania Shirdi offers high-end air-conditioned buses with plush seating, modern interiors, and professional drivers. Perfect for VIP pilgrims, special temple visits, corporate outings, and luxury family tours."
},
{
"name": "Affordable Urbania Hire Shirdi",
"description": "Affordable Urbania Hire Shirdi provides budget-friendly bus rental options for temple darshan, local sightseeing, and group travel without compromising on comfort, safety, or convenience."
},
{
"name": "Chauffeur Driven Urbania Shirdi",
"description": "Chauffeur Driven Urbania Shirdi ensures a stress-free travel experience with verified and experienced drivers. Ideal for pilgrims, families, and groups who want a safe and comfortable ride across Shirdi."
},
{
"name": "Urbania for Temple Darshan Shirdi",
"description": "Urbania for Temple Darshan Shirdi offers spacious and comfortable buses for Sai Baba temple visits and local darshan tours. Ensures punctual service, comfort, and smooth travel for devotees."
},
{
"name": "Urbania for Pilgrimage Tours Shirdi",
"description": "Urbania for Pilgrimage Tours Shirdi provides organized and reliable transport for religious tours and spiritual journeys. Features comfortable seating, AC options, and experienced drivers for peaceful pilgrimage travel."
},
{
"name": "Best Urbania Rental Shirdi",
"description": "Best Urbania Rental Shirdi offers top-rated Urbania buses with excellent customer service, timely pickups, and comfortable travel for temple visits, local, and outstation trips. Suitable for pilgrims, families, and groups."
},
{
"name": "Urbania Group Travel Shirdi",
"description": "Urbania Group Travel Shirdi provides large-capacity buses for group darshan, pilgrimage tours, and excursions. Ensures safe, comfortable, and convenient travel for devotees, families, and tour groups."
},
{
"name": "Reliable Urbania Hire Shirdi",
"description": "Reliable Urbania Hire Shirdi offers dependable and punctual Urbania bus services for temple, city, and outstation travel. Known for safety, comfort, and professional drivers, making pilgrimage travel seamless and enjoyable."
}
],
"tableData": [
["Urbania Bus on Rent in Shirdi", "Shirdi Urbania Bus Hire"],
["Urbania Rental Service Shirdi", "Urbania AC Bus on Rent Shirdi"],
["Corporate Urbania Hire Shirdi", "Urbania for Outstation Shirdi"],
["Urbania Airport Transfer Shirdi", "Luxury Urbania Shirdi"],
["Affordable Urbania Hire Shirdi", "Chauffeur Driven Urbania Shirdi"],
["Urbania for Temple Darshan Shirdi", "Urbania for Pilgrimage Tours Shirdi"],
["Best Urbania Rental Shirdi", "Urbania Group Travel Shirdi"],
["Reliable Urbania Hire Shirdi", ""]
],



"whychoose": [
    {
        "WhyChooseheading": "Reliable Urbania Bus On Rent in Shirdi",
        "WhyChoosedescription": "Urbania Bus On Rent in Shirdi is perfect for group travel, family pilgrimages, corporate trips, weddings, temple visits, and outstation journeys, providing comfort and spacious seating."
    },
    {
        "WhyChooseheading": "Spacious and Well-Equipped Force Urbania Bus",
        "WhyChoosedescription": "Urbania Bus On Rent in Shirdi offers modern Force Urbania buses with air-conditioning, ample legroom, and comfortable pushback seating for long and short trips."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Urbania Bus On Rent in Shirdi comes with skilled drivers familiar with Shirdi, Nashik, Pune, and nearby routes, ensuring safe, timely, and hassle-free travel."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Choose Urbania Bus On Rent in Shirdi for competitive rates with no hidden charges, making group and pilgrimage travel budget-friendly."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Urbania Bus On Rent in Shirdi provides round-the-clock booking assistance and support for inquiries, reservations, and last-minute travel needs."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "Urbania Bus On Rent in Shirdi is available for hourly rentals, full-day bookings, multi-day trips, pilgrimage tours, corporate travel, and customized packages."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Buses",
        "WhyChoosedescription": "All buses for Urbania Bus On Rent in Shirdi are regularly cleaned, sanitized, and maintained to ensure passenger safety and comfort."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Urbania Bus On Rent in Shirdi guarantees on-time pickups and dependable service, ensuring smooth and stress-free travel experiences."
    }
]
}

const faqData = [
    {
        question: 'Is Urbania Bus On Rent in Shirdi available for local and outstation travel?',
        answer: 'Yes, Urbania Bus On Rent in Shirdi can be booked for local travel, pilgrimage tours, corporate trips, and long-distance journeys.',
    },
    {
        question: 'How can I book Urbania Bus On Rent in Shirdi?',
        answer: 'You can book Urbania Bus On Rent in Shirdi via phone, WhatsApp, or online for easy and quick reservations.',
    },
    {
        question: 'Why choose Urbania Bus On Rent in Shirdi?',
        answer: 'Urbania Bus On Rent in Shirdi offers spacious seating, professional drivers, clean buses, and transparent pricing for group and pilgrimage travel.',
    },
    {
        question: 'Are drivers experienced?',
        answer: 'Yes, all drivers for Urbania Bus On Rent in Shirdi are licensed, trained, and experienced in handling Force Urbania buses safely.',
    },
    {
        question: 'Can I customize pickup and drop-off locations?',
        answer: 'Absolutely. Urbania Bus On Rent in Shirdi allows flexible pickup and drop locations across Shirdi and nearby areas.',
    },
    {
        question: 'Is Urbania Bus On Rent in Shirdi available 24x7?',
        answer: 'Yes, Urbania Bus On Rent in Shirdi operates 24x7 to meet your travel needs anytime.',
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all buses are regularly sanitized, cleaned, and maintained to ensure passenger safety and comfort.',
    },
    {
        question: 'What payment options are available?',
        answer: 'Urbania Bus On Rent in Shirdi accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during trips?',
        answer: 'Yes, dedicated customer support is available throughout your journey for smooth and stress-free travel.',
    },
    {
        question: 'Can Urbania Bus be used for pilgrimage, corporate, and family trips?',
        answer: 'Yes, Urbania Bus On Rent in Shirdi is ideal for pilgrimage tours, group trips, corporate travel, and family outings.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Ganesh Pawar',
        feedback: 'Urbania Bus On Rent in Shirdi provided a very comfortable journey for our Sai Baba pilgrimage. Clean bus and excellent service.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Pooja Kulkarni',
        feedback: 'We hired Urbania Bus On Rent in Shirdi for a family trip. The bus was spacious, punctual, and very well-maintained.',
        rating: 5,
    },
    {
        id: 3,
        name: 'Mr. Nilesh Deshpande',
        feedback: 'Urbania Bus On Rent in Shirdi made our group travel smooth and peaceful. Highly recommended service.',
        rating: 5,
    },
];





























































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania Bus On Rent in Shirdi",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-shirdi.jpg",
  "description": "Urbania Bus On Rent in Shirdi offers AC and non-AC Urbania buses for temple darshan, pilgrimage tours, corporate trips, outstation travel, airport transfers, weddings, office trips, and group travel. Chauffeur-driven Urbania buses ensure safe, comfortable, and reliable transportation in Shirdi and nearby locations.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/urbania-bus-on-rent-shirdi"
  }
};






    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Urbania Bus On Rent in Shirdi | AC & Luxury Urbania Bus Hire 
  </title>

  <meta
    name="description"
    content="Book Urbania Bus On Rent in Shirdi for Sai Baba temple darshan, pilgrimage tours, outstation travel, airport transfers, corporate trips, and group travel. AC and non-AC Urbania buses with chauffeur-driven service ensure safe, comfortable, and reliable transportation in Shirdi."
  />

  <meta
    name="keywords"
    content="Urbania Bus on Rent in Shirdi, Shirdi Urbania Bus Hire, Urbania Rental Service Shirdi, Urbania AC Bus on Rent Shirdi, Corporate Urbania Hire Shirdi, Urbania for Outstation Shirdi, Urbania Airport Transfer Shirdi, Luxury Urbania Shirdi, Affordable Urbania Hire Shirdi, Chauffeur Driven Urbania Shirdi, Urbania for Temple Darshan Shirdi, Urbania for Pilgrimage Tours Shirdi, Best Urbania Rental Shirdi, Urbania Group Travel Shirdi, Reliable Urbania Hire Shirdi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/72.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniabusonrentinshirdi;